<template>
  <div id="map">
    <div id="main"></div>
  </div>
</template>

<script>
// @ is an alias to /src
import * as echarts from "echarts";
import {
  onMounted,
  inject,
  onUnmounted,
  reactive,
  watchEffect,
  nextTick,
} from "@vue/runtime-core";
import kaizhou from "../../utils/kaizhou";
import { region } from "@/api/dataAnalysis/populationAnalysis.js";
import { unitRegion } from "@/api/dataAnalysis/unitOfAnalysis.js";
import { analyseeventregion } from "@/api/dataAnalysis/eventAnalysis.js";
import { region as housingregion } from "@/api/dataAnalysis/housingAnalysis.js";
import { carregion } from "@/api/dataAnalysis/carAnalysis.js";

export default {
  setup() {
    const state = reactive({
      myChart: null,
      tiemOut: null,
    });
    const active = inject("active").value;
    const regionAxios = async () => {
      const params = {
        type: 0,
      };
      let res;

      if (active === 0) {
        res = await region(params);
      } else if (active === 1) {
        res = await housingregion(params);
      } else if (active === 2) {
        res = await unitRegion(params);
      } else if (active === 3) {
        res = await analyseeventregion(params);
      } else if (active === 4) {
        res = await region(params);
      } else if (active === 5) {
        res = await carregion(params);
      }

      return res.data.map((item) => {
        return item;
      });
    };

    onMounted(async () => {
      // debugger
      state.tiemOut = setTimeout(async () => {
        let chartDom = document.getElementById("main");
        if (chartDom) state.myChart = echarts.init(chartDom);
        let option;
        const data = await regionAxios();
        echarts.registerMap("CQ", kaizhou);
        state.myChart &&
          state.myChart.setOption(
            (option = {
              title: {
                sublink:
                  "http://zh.wikipedia.org/wiki/%E9%A6%99%E6%B8%AF%E8%A1%8C%E6%94%BF%E5%8D%80%E5%8A%83#cite_note-12",
              },
              tooltip: {
                trigger: "item",
                position: (item) => {
                  item[1] = item[1] - 70;
                  return item;
                },
                formatter: (item) => {
                  return `<span>${item.data.name}</span><div style='text-align:center;font-weight: bold;'>${item.data.value}</div>`;
                },
              },
              data: {
                itemStyle: {
                  borderMiterLimit: 10,
                  shadowColor: "#fff",
                  shadowBlur: 1000,
                  shadowOffsetY: 1000,
                },
              },
              series: [
                {
                  type: "map",
                  map: "CQ",
                  label: {
                    // show:true,
                    color: "#fff",
                    normal: {
                      textStyle: {
                        fontSize: 15,
                        fontWeight: "bold",
                        color: "#fff",
                      },
                    },
                  },
                  // 自定义名称映射
                  itemStyle: {
                    normal: {
                      areaColor: "#013770", // 蓝色
                      borderColor: "#0397da",
                      borderWidth: 2,
                      shadowColor: "#0397da",
                      shadowBlur: 20,
                      opacity: 0.8,
                      label: {
                        color: "#fff",
                        textStyle: {
                          color: "#fff",
                        },
                      },
                    },
                    // 选中样式
                    emphasis: {
                      areaColor: "#2DC2DA", // hover高亮色
                      borderColor: "#fff",
                      borderWidth: 3,
                      label: {
                        show: true,
                        textStyle: {
                          color: "#fff",
                        },
                      },
                    },
                  },
                  data: data,
                },
              ],
            })
          );
        option && state.myChart.setOption(option, true);
      }, 1000);
    });
    onUnmounted(() => {
      state.myChart && state.myChart.clear();
      state.myChart && state.myChart.dispose();
      clearTimeout(state.tiemOut);
      console.log(6666666666);
      state.tiemOut = null;
    });
  },
};
</script>

<style lang="scss" scoped>
#map {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 10%;
  #main {
    position: relative;
    width: 500px;
    height: 500px;
  }
}
</style>
